<!-- <div *ngIf="!mariner">
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Visa Details</h5>
    <div class="row mx-0 mt-5 pb-5">
        <div class="col-lg-6 pe-md-5">
            <div class="form-floating mb-md-5 mb-4">
                <select class="form-select" [(ngModel)]="docType" id="docType" (change)="docError = false">
                    <option *ngFor="let list of docTypeList; let i = index" [value]="list.DocumentTypeId">{{list.Name}}</option>
                </select>
                <label for="docType" [ngClass]="docType ? '': 'form-select-label'">Select Proof <span class="text-danger">*</span></label>
                <div class="text-danger small my-4" *ngIf="docError">
                    Please select document type
                </div>
            </div>
            <div>
                <nri-app-img-upld [imageName]="'Visa'" [docTypeID]="docType" (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioociimg></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="visaImgempty">
                    Please upload your visa image
                </div>
            </div>
        </div>
        <div class="col-lg-6 pe-md-5">
            <div class="input-group border form-floating mb-4">
                <input class="form-control ms-3 my-2  border-0 pe-0 ps-3 py-0" readonly [(ngModel)]="visaExpiryDt" placeholder="Enter Visa Expiry" ngx-mydatepicker (click)="dp.toggleCalendar()" name="mydate"
                 [options]="options" id="pExpiry" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event)" required/>
                <label for="pExpiry">Visa Expiry <span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                </span>
            </div>
            <div *ngIf="expiryDateError">
                <span class="small text-danger">Visa expiry date should not be within 15 days.</span>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-end h-100 mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
           <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="!visaUpdt || expiryDateError || !visaExpiryDate" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div> -->

<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Visa Details</h5>
    <div class="row mx-0 mt-5 pb-5">
        <div class="col-lg-6 pe-md-5">
            <div class="input-group border form-floating mb-4 rounded-2">
                <input class="form-control ms-0 my-1 border-0 pe-0 py-0" [(ngModel)]="lastArrivalDt" readonly placeholder="Enter Last Arrival in India" ngx-mydatepicker (click)="dp.toggleCalendar()" name="mydate"
                 [options]="options2" [defaultMonth]="defaultMonth.defMonth" id="pExpiry" #dp="ngx-mydatepicker" (dateChanged)="onDateArrival($event)" required/>
                <label for="pExpiry">Select Visa Expiry<span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                </span>
            </div>
            <div *ngIf="arrivalDateError">
                <span class="small text-danger">Visa Expiry should be above 60 days.</span>
            </div>
        </div>
        <div class="col-lg-6 pe-md-5"></div>
        <div class="col-lg-6 pe-md-5">
            <div>
                <nri-app-img-upld [imageName]="'VISA'" (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioociimg></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="visaImgempty">
                    Please upload your visa Front image
                </div>
            </div>
        </div>
            <div class="col-lg-6 pe-md-5">
            <div>
                <nri-app-img-upld [imageName]="'VISABACK'" (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioociimg></nri-app-img-upld>
                <!-- <div class="text-danger small mb-4" *ngIf="visaImgemptyback">
                    Please upload your visa Back image
                </div> -->
            </div>
        </div>
        <div class="col-lg-6 pe-md-5">
            <nri-app-img-upld [imageName]="'VISAAdd'" [additionalImageName]="'Additional'" (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioociimg></nri-app-img-upld>
        </div>
        
    </div>
    <div class="d-flex align-items-end mx-0  mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="!pdf1Updt || arrivalDateError || !lastArrivalDate" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>